import React, { useEffect } from "react";
import { connect } from "react-redux";
import setCoverPresent from '../redux/actions';
import CaseStudyPage from '../components/CaseStudyPage';
import ProjectModel from '../models/ProjectModel';

function ShapeOfSense({ dispatch }) {
  useEffect(() => {
    dispatch(setCoverPresent('no'));
  }, []);

  const model = {
    ...ProjectModel.ShapeOfSense,
    sections: [
      {
        type: 'hover-grid',
        cols: 4,
        gap: '12px',
        caption: 'Key graphics',
        items: [
          { src: 'img/project-page/google-tsos/google-theshapeofsense-MariaChimishkyan-a2.jpg', hoverSrc: 'img/project-page/google-tsos/google-theshapeofsense-MariaChimishkyan-a1.jpg' },
          { src: 'img/project-page/google-tsos/google-theshapeofsense-MariaChimishkyan-b2.jpg', hoverSrc: 'img/project-page/google-tsos/google-theshapeofsense-MariaChimishkyan-b1.jpg' },
          { src: 'img/project-page/google-tsos/google-theshapeofsense-MariaChimishkyan-c2.jpg', hoverSrc: 'img/project-page/google-tsos/google-theshapeofsense-MariaChimishkyan-c1.jpg' },
          { src: 'img/project-page/google-tsos/google-theshapeofsense-MariaChimishkyan-d2.jpg', hoverSrc: 'img/project-page/google-tsos/google-theshapeofsense-MariaChimishkyan-d1.jpg' },
          { src: 'img/project-page/google-tsos/google-theshapeofsense-MariaChimishkyan-e2.jpg', hoverSrc: 'img/project-page/google-tsos/google-theshapeofsense-MariaChimishkyan-e1.jpg' },
          { src: 'img/project-page/google-tsos/google-theshapeofsense-MariaChimishkyan-f2.jpg', hoverSrc: 'img/project-page/google-tsos/google-theshapeofsense-MariaChimishkyan-f1.jpg' },
          { src: 'img/project-page/google-tsos/google-theshapeofsense-MariaChimishkyan-g2.jpg', hoverSrc: 'img/project-page/google-tsos/google-theshapeofsense-MariaChimishkyan-g1.jpg' },
          { src: 'img/project-page/google-tsos/google-theshapeofsense-MariaChimishkyan-h2.jpg', hoverSrc: 'img/project-page/google-tsos/google-theshapeofsense-MariaChimishkyan-h1.jpg' },
        ],
      },
      {
        type: 'full',
        src: 'img/project-page/google-tsos/google-theshapeofsense-MariaChimishkyan.mp4',
        caption: 'Open Film / Countdown',
      },
      { type: 'full', src: 'img/project-page/google-tsos/google-theshapeofsense-MariaChimishkyan-site.gif', caption: 'Site' },
      {
        type: 'half',
        images: [
          { src: 'img/project-page/google-tsos/google-theshapeofsense-MariaChimishkyan-chat.gif', caption: 'Chat' },
          { src: 'img/project-page/google-tsos/google-theshapeofsense-MariaChimishkyan-email.gif', caption: 'Email' },
        ],
      },
     
      { type: 'full', src: 'img/project-page/google-tsos/google-theshapeofsense-MariaChimishkyan-intro.gif', caption: 'Intro' },
      {
        type: 'third',
        cols: 2,
        rowGap: '12px',
        caption: 'Speaker thumbnails',
        images: [
          { src: 'img/project-page/google-tsos/google-theshapeofsense-MariaChimishkyan-pp-1.gif' },
          { src: 'img/project-page/google-tsos/google-theshapeofsense-MariaChimishkyan-pp-2.gif' },
          { src: 'img/project-page/google-tsos/google-theshapeofsense-MariaChimishkyan-pp-3.gif' },
          { src: 'img/project-page/google-tsos/google-theshapeofsense-MariaChimishkyan-pp-5.gif' },
        ],
      },
      {
        type: 'color-palette',
        colors: [
          { name: 'Brick',    pantone: '474U',        cmyk: '6, 32, 35, 0',  rgb: '235, 182, 158', hex: '#EBB69E' },
          { name: 'Pink',     pantone: '705U',         cmyk: '0, 18, 10, 0',  rgb: '252, 216, 212', hex: '#FCD8D4' },
          { name: 'Sage',     pantone: '563U',         cmyk: '53, 25, 41, 0', rgb: '130, 163, 154', hex: '#82A39A' },
          { name: 'Lavender', pantone: '263U',         cmyk: '11, 20, 0, 0',  rgb: '221, 204, 228', hex: '#DDCCE4' },
          { name: 'White',    pantone: null,           cmyk: '0, 0, 0, 0',    rgb: '255, 255, 255', hex: '#FFFFFF' },
          { name: 'Sand',     pantone: 'Cool Gray 1U', cmyk: '5, 6, 5, 0',    rgb: '239, 234, 233', hex: '#EFEAE9' },
          { name: 'Metallic', pantone: null,           cmyk: '0, 0, 0, 26',   rgb: '198, 198, 198', hex: '#C6C6C6' },
          { name: 'Charcoal', pantone: 'Black 3U',     cmyk: '0, 0, 0, 95',   rgb: '48, 48, 48',    hex: '#303030' },
        ],
      },
    ],
  };

  return <CaseStudyPage projectModel={model} />;
}

export default connect()(ShapeOfSense);
